import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { Select, DatePicker, Space } from 'antd';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {
  collection,
  getDocs,
  query,
  writeBatch,
  where,
  doc,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { useSelector } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';

import { TextField } from '@material-ui/core';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const { Option } = Select;
const { RangePicker } = DatePicker;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CouponManageDialog(props) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setloading] = useState(false);
  const [size, setSize] = useState(0);
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userWalletRedux = useSelector((state) => state.walletReducer);
  const [selectedNfts, setselectedNfts] = useState([]);
  const [usageLimit, setusageLimit] = useState('');

  const [couponData, setcouponData] = useState({
    promoCode: '',
    type: 'PERCENTAGE', //PERCENTAGE, PRICE
    startTimestamp: '',
    endTimestamp: '',
    value: '',
  });
  const [currentDate, setCurrentDate] = useState();

  const removeDuplicates = (data, key) => {
    return [...new Map(data.map((item) => [key(item), item])).values()];
  };
  const handleClose = () => {
    props.setdialogState(false);
  };
  const createCoupon = async (e) => {
    e.preventDefault();
    setloading(true);

    try {
      let couponObj = { ...couponData };
      if (!couponObj.startTimestamp || !couponObj.endTimestamp) {
        toast.error(`Please provide the valid start/ end time for coupon!`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);

        return null;
      }
      if (!selectedNfts || selectedNfts.length === 0) {
        toast.error(`Please select the NFTs for this coupon!`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);

        return null;
      }

      ////////////validating pormo text
      let promoCodeText = couponObj.promoCode;

      let rejectionReason = null;

      if (
        promoCodeText.slice(0, 1) === '.' ||
        promoCodeText.slice(promoCodeText.length - 1, promoCodeText.length) ===
          '.'
      ) {
        rejectionReason =
          'Promo code can begin or end with non-alphanumeric characters except periods (.).';
      } else if (promoCodeText.includes(' ')) {
        rejectionReason = 'The promo code should be only one word.';
      } else if (promoCodeText.length < 6 || promoCodeText.length > 30) {
        rejectionReason = 'Promo code should be between 6-30 characters.';
      }

      if (rejectionReason) {
        toast.error(rejectionReason, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        return;
      }

      //checking for duplicates
      let isDuplicate = false;
      await Promise.all(
        selectedNfts.map(async (ele) => {
          const q = query(
            collection(
              firebaseFireStore,
              'musicartNfts',
              ele.data.tokenId,
              'coupons',
            ),
            where('promoCode', '==', promoCodeText),
          );

          let snap = await getDocs(q);

          if (ele.data.isMultiple) {
            let eleNftIds = [];
            Object.values(ele.data.multipleNftDetails).map((multiEle) => {
              if (multiEle.userId === userDataRedux.uid && multiEle.nftId) {
                eleNftIds.push(multiEle.nftId);
              }
            });

            snap.forEach((doc, index) => {
              if (doc.data().nftId && eleNftIds.includes(doc.data().nftId)) {
                isDuplicate = true;
              }
            });
          } else if (!ele.data.isMultiple && !snap.empty) {
            isDuplicate = true;
          }
        }),
      );

      if (isDuplicate) {
        toast.error('Promo code already exists.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        return;
      }

      ////////////end promo code validation
      couponObj.value = Number(couponObj.value);

      //
      let isUsageLimitEnabled = false;
      if (usageLimit && Number(usageLimit) !== 0 && usageLimit !== '') {
        isUsageLimitEnabled = true;
      }

      let batch = writeBatch(firebaseFireStore);
      let modifiedObj = [...props.codesList];
      selectedNfts.map((ele) => {
        let dbObj = { ...couponObj };
        dbObj.tokenId = ele.data.tokenId;

        if (isUsageLimitEnabled) {
          let couponId = uuidv4();
          let couponRef = doc(
            firebaseFireStore,
            'musicartNfts',
            ele.data.tokenId,
            'coupons',
            couponId,
          );
          dbObj.couponId = couponId;
          dbObj.couponType = 'WITH_USAGE_LIMIT';
          dbObj.usage = 0;
          dbObj.usageLimit = Number(usageLimit);
          dbObj.creatorId = userDataRedux.uid;
          dbObj.title = ele.data.tokenName;
          dbObj.isMultiple = ele.data.isMultiple;

          //for multiple
          let subNfts = null;
          if (ele.data.isMultiple) {
            Object.values(ele.data.multipleNftDetails).map(
              async (multiEle, index2) => {
                if (
                  multiEle.userId === userDataRedux.uid &&
                  ele.data.tokenId &&
                  multiEle.nftId
                ) {
                  if (!subNfts) {
                    subNfts = {};
                  }
                  subNfts[multiEle.nftId] = {
                    nftId: multiEle.nftId,
                    index: multiEle.index,
                  };
                }
              },
            );
          }

          if (subNfts) {
            dbObj.subNfts = subNfts;
          }

          batch.set(couponRef, dbObj);

          modifiedObj.push({
            ...dbObj,
            key: couponId,
          });
        } else if (ele.data.isMultiple) {
          dbObj.isMultiple = ele.data.isMultiple;

          Object.values(ele.data.multipleNftDetails).map(
            async (multiEle, index2) => {
              if (
                multiEle.userId === userDataRedux.uid &&
                ele.data.tokenId &&
                multiEle.nftId
              ) {
                let couponId = uuidv4();
                let couponRef = doc(
                  firebaseFireStore,
                  'musicartNfts',
                  ele.data.tokenId,
                  'coupons',
                  couponId,
                );
                dbObj.couponId = couponId;

                dbObj.nftId = multiEle.nftId;
                dbObj.index = multiEle.index;

                batch.set(couponRef, dbObj);

                modifiedObj.push({
                  ...dbObj,
                  title: ele.data.tokenName,
                  key: couponId,
                });
              }
            },
          );
        } else {
          let couponId = uuidv4();
          let couponRef = doc(
            firebaseFireStore,
            'musicartNfts',
            ele.data.tokenId,
            'coupons',
            couponId,
          );
          dbObj.couponId = couponId;
          batch.set(couponRef, dbObj);

          modifiedObj.push({
            ...dbObj,
            title: ele.data.tokenName,
            key: couponId,
          });
        }
      });

      await batch.commit();
      await props.getNftsCouponsList();
      setloading(false);
      toast.success('Coupon created successfully', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setcouponData({
        promoCode: '',
        type: 'PERCENTAGE', //PERCENTAGE, PRICE
        startTimestamp: couponData.startTimestamp,
        endTimestamp: couponData.endTimestamp,
        value: '',
      });
      setusageLimit('');
      handleClose();

      // props.setcodesList(modifiedObj)
    } catch (err) {
      toast.error(err.message, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      setloading(false);
    }
  };

  const nftSelectionHandler = (value, obj) => {
    setselectedNfts([...obj]);
  };

  const dateHandler = (dates, dateStrings) => {
    if (dates && dates[0] && dates[1]) {
      let modifiedObj = {
        ...couponData,
      };
      modifiedObj.startTimestamp = dates[0].format('x');
      modifiedObj.endTimestamp = dates[1].format('x');
      setcouponData(modifiedObj);
    }
  };
  const startDateHandler = (dates) => {
    if (dates) {
      setStartDate(dates);
      let modifiedObj = {
        ...couponData,
      };
      modifiedObj.startTimestamp = dates.valueOf();
      setcouponData(modifiedObj);
    }
  };
  const endDateHandler = (dates) => {
    if (dates) {
      setEndDate(dates);
      let modifiedObj = {
        ...couponData,
      };

      modifiedObj.endTimestamp = dates.valueOf();
      setcouponData(modifiedObj);
    }
  };

  const getDisabledHours = () => {
    var hours = [];
    for (var i = 0; i < moment().hour(); i++) {
      hours.push(i);
    }
    return hours;
  };

  const getDisabledMinutes = (selectedHour) => {
    var minutes = [];
    if (selectedHour === moment().hour()) {
      for (var i = 0; i < moment().minute(); i++) {
        minutes.push(i);
      }
    }
    return minutes;
  };
  function disabledDate(current) {
    // Can not select days before today and today
    // setCurrentDate(current)
    return current < moment().startOf('day');
  }
  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }
  function disabledDateTime(e) {
    if (e !== null) {
      return {
        disabledHours: () =>
          new Date(e).getDate() <= new Date().getDate()
            ? range(0, 24).splice(
                0,
                new Date(e).getHours() === new Date().getHours() &&
                  new Date(e).getDate() === new Date().getDate()
                  ? new Date(e).getHours()
                  : new Date().getHours(),
              )
            : [],
        disabledMinutes: () =>
          new Date(e).getDate() <= new Date().getDate()
            ? range(0, 60).splice(
                0,
                new Date(e).getMinutes() === new Date().getMinutes()
                  ? new Date(e).getMinutes()
                  : new Date().getMinutes(),
              )
            : [],
        disabledSeconds: () => [],
      };
    } else {
      return {
        disabledHours: () =>
          new Date(e).getDate() <= new Date().getDate()
            ? range(0, 24).splice(0, new Date().getHours())
            : [],
        disabledMinutes: () =>
          new Date(e).getDate() <= new Date().getDate()
            ? range(0, 60).splice(0, new Date().getMinutes())
            : [],
        disabledSeconds: () => [],
      };
    }
  }
  const isSmallerScreen = 500;
  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
  }, [size]);

  const handleSize = () => {
    setSize(window.innerWidth);
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="md"
      onClose={handleClose}
    >
      <DialogContent
        className="sign__form sign__form--mint w-full"
        style={{ marginTop: 0 }}
      >
        <div className="w-full md:py-4 sm:py-4 px-4">
          <h5 className="text-lg font-semibold sign__title">Create Coupon</h5>
          <div className="dialog-close-medium">
            <button
              className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <form onSubmit={createCoupon} className="w-full mb-1">
          <div className="row mt-2 w-full">
            <div className="w-full px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="code-field">
                  Promo Code
                </label>
                <input
                  id="code-field"
                  type="text"
                  className="sign__input"
                  placeholder="e.g. 20percentOff"
                  required
                  value={couponData.promoCode}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...couponData,
                    };
                    modifiedObj.promoCode = e.target.value;
                    setcouponData(modifiedObj);
                  }}
                />
                {couponData &&
                  couponData.promoCode &&
                  couponData.promoCode.length > 0 && (
                    <button
                      type="button"
                      onClick={() => {
                        let modifiedObj = {
                          ...couponData,
                        };
                        modifiedObj.promoCode = '';
                        setcouponData(modifiedObj);
                      }}
                      className="close_icon"
                    >
                      <HighlightOffIcon />
                    </button>
                  )}
              </div>
            </div>

            <div className="w-full md:w-4/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="type-field">
                  Coupon Type
                </label>

                <select
                  id="type-field"
                  className="sign__select"
                  value={couponData.type}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...couponData,
                    };
                    modifiedObj.type = e.target.value;
                    setcouponData(modifiedObj);
                  }}
                >
                  <option value="PERCENTAGE">Percentage Off</option>
                  <option value="PRICE">Fixed Price Off</option>
                </select>
              </div>
            </div>
            <div className="w-full md:w-4/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="valueField">
                  {couponData.type === 'PERCENTAGE'
                    ? 'Percentage Off (%)'
                    : 'Price Off (USD)'}
                </label>
                <input
                  id="valueField"
                  autocomplete="off"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  name="itemname"
                  className="sign__input"
                  placeholder="e.g. 5"
                  required
                  value={couponData.value}
                  onChange={(e) => {
                    let modifiedObj = {
                      ...couponData,
                    };
                    modifiedObj.value = e.target.value;
                    setcouponData(modifiedObj);
                  }}
                  disabled={couponData.isMultiple ? true : false}
                />
                {couponData && couponData.value && couponData.value.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      let modifiedObj = {
                        ...couponData,
                      };
                      modifiedObj.value = '';
                      setcouponData(modifiedObj);
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>
            <div className="w-full md:w-4/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="valueField">
                  Select NFTs
                </label>
                <div className="multi_select_con">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    onChange={nftSelectionHandler}
                    className="multi_select"
                    id="valueField"
                    showSearch
                    filterOption={(input, option) => {
                      if (option && option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {removeDuplicates(
                      props.walletOwnedNfts,
                      (item) => item.tokenName,
                    ) &&
                    removeDuplicates(
                      props.walletOwnedNfts,
                      (item) => item.tokenName,
                    ).length > 0 ? (
                      removeDuplicates(
                        props.walletOwnedNfts,
                        (item) => item.tokenName,
                      ).map((ele, index) => {
                        return (
                          <Option key={ele.tokenId + index} data={ele}>
                            {ele.tokenName}
                          </Option>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Select>
                </div>
              </div>
            </div>

            <div className="w-full md:w-4/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="valueField">
                  Usage Limit
                  <Tooltip
                    enterTouchDelay={0}
                    title="Limit number of times this coupon can be used in total. Default is no restriction."
                  >
                    <HelpIcon
                      style={{
                        fontSize: 18,
                        marginLeft: 10,
                        position: 'absolute',
                      }}
                    />
                  </Tooltip>
                </label>
                <input
                  id="valueField"
                  autocomplete="off"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  name="itemname"
                  className="sign__input"
                  placeholder="e.g. 1"
                  value={usageLimit}
                  min="1"
                  onChange={(e) => {
                    setusageLimit(e.target.value);
                  }}
                />
                {usageLimit && usageLimit.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      setusageLimit('');
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="sign__group">
                <label className="sign__label" htmlFor="type-field">
                  Coupon Start/ End Date
                </label>
                <div className="multi_select_con">
                  {size > isSmallerScreen ? (
                    <Space direction="horizontal" size={12}>
                      <RangePicker
                        required
                        ranges={{
                          Today: [moment(), moment().endOf('day')],
                          'This Month': [
                            moment().startOf('day'),
                            moment().endOf('month'),
                          ],
                        }}
                        showTime
                        disabledHours={getDisabledHours}
                        disabledMinutes={getDisabledMinutes}
                        format="YYYY/MM/DD HH:mm"
                        onChange={dateHandler}
                        disabledDate={disabledDate}
                        // disabledTime={disabledDateTime}
                        className="antd_date_picker capitalize"
                      />
                    </Space>
                  ) : (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Start Date"
                        value={startDate}
                        onChange={startDateHandler}
                        className="startDate"
                        minDate={new Date()}
                        maxDate={endDate}
                      />
                      <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="End Date"
                        value={endDate}
                        onChange={endDateHandler}
                        minDate={startDate}
                        className="endDate"
                      />
                    </LocalizationProvider>
                  )}
                </div>
              </div>
            </div>

            {/* //create */}
            <div
              style={{
                display: 'block',
                width: '100%',
              }}
            >
              <div
                style={{
                  width: 150,
                  height: 50,
                }}
                className="mt-2 px-4"
              >
                {loading ? (
                  <div className="flex justify-center	w-full text-center">
                    <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                  </div>
                ) : (
                  <button
                    className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150 w-full"
                    type="submit"
                  >
                    Create
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
